import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-branches',
  templateUrl: './edit-branches.component.html',
  styleUrls: ['./edit-branches.component.scss']
})
export class EditBranchesComponent implements OnInit {
  entityForm: FormGroup;
  mediaForm : FormGroup
  imagePreview: string | null = null;
  isDisabled: boolean = true;
  countries: any
  mediaUrl : any
  groupAgeForm: FormGroup;
groupId: any;
  public arrCountries: any[] = [];

  entities:any
  selectedFile: File;
  mediaName : any
  public tempData = [];
selectedGroup: any; // store fetched group data for placeholder display
  constructor(private fb: FormBuilder,
    private apisService: ApisService ,
    private toastr :ToastrService,
    private loading :LoadingService, 
    private modal : NgbModal, 
    private router : Router,
    private route: ActivatedRoute
  ) {
    this.groupAgeForm = this.fb.group({
    name: ['', Validators.required ],
    minAge: [null, Validators.required],
    maxAge: [null, Validators.required],
  });
  }

 ngOnInit(): void {
  this.groupId = this.route.snapshot.paramMap.get('id'); // or pass it manually

  this.apisService.getBranchesId(this.groupId).subscribe({
    next: (res) => {
      this.groupAgeForm.patchValue(res.data); // fills the form fields like name, minAge, maxAge
    },
    error: (err) => {
      console.error("Failed to load group", err);
    }
  });

      this.getGroupedAge();

}
  
  /*----------  Uploading Media  ----------*/
  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
  
    // Update the form with the file name
    const filesArray = this.mediaForm.get('files') as FormArray;
    const fileGroup = filesArray.at(0) as FormGroup;
    fileGroup.patchValue({ name: file.name });
  
    // Preview the image
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
      this.isDisabled = false;
    };
    reader.readAsDataURL(file);

    // Optionally store the file itself for upload
    this.selectedFile = file;
    console.log(this.selectedFile);
  }
  
  /*----------  Zoom function  ----------*/
  zoom(content:any){
    this.modal.open(content, { size: 'lg' , centered : true  });
  }
  

  // onFileSelected(event: Event): void {
  //   const file = (event.target as HTMLInputElement).files?.[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       this.imagePreview = reader.result as string;
  //       this.isDisabled = false;
  //     };
  //     reader.readAsDataURL(file);  
  // }

onEditGroupAge() {
  if (this.groupAgeForm.invalid) {
    this.toastr.error("Please fill in all required fields.");
    return;
  }

  const data = this.groupAgeForm.value;  // like updated profile info
  const id = this.groupId;               // same ID we used to fetch the record

  this.loading.show();
  this.apisService.editBranches(id, data).subscribe({
    next: (res) => {
      this.loading.hide();
      this.toastr.success("Group age updated successfully!");
      this.router.navigate(['/group-ages']);  // redirect after success
    },
    error: (err) => {
      this.loading.hide();
      this.toastr.error("Update failed.");
      console.error(err);
    },
  });
}



 getGroupedAge() {
  this.loading.show();
  this.apisService.getGroupedAge().subscribe({
    next: (data) => {
      this.loading.hide();
      this.tempData = data.data;
      this.arrCountries = this.tempData;

      this.selectedGroup = this.tempData.find((group: any) => group.id == this.groupId);
      if (!this.selectedGroup) {
        this.toastr.error("Group not found.");
      }

      console.log("Selected group:", this.selectedGroup);
    },
    error: (error) => {
      this.loading.hide();
      console.error("API Error:", error);
    },
  });
}



resetGroupAgeForm() {
  this.groupAgeForm.reset();
}




// submitting the form
  onSubmit() {
 
    console.log("Submitting entity...",this.mediaForm.value);
    if (this.entityForm.valid && this.mediaForm.valid) {
      console.log('Form Data:', this.entityForm.value);
      console.log('Form Submitted Successfully');
  
    } else {
      console.log('Please fill all required fields');
      console.log(this.entityForm.value);
    }
  }



/*----------  Reset Button  ----------*/
resetForm() {
  this.entityForm.reset();
}
  

}
